import { useState, useEffect, useCallback } from "react";
import {useSelector} from 'react-redux';
import 'react-tippy/dist/tippy.css';
import DetailedResultsTable from "./DetailedResultsTable";
import { saveExcel } from "../../../utils/excel.mjs";

function QuizScoring() {
	const { unMappedUserResults, currentCampaign } = useSelector(state => state.user);
	const [calculatedResults, setCalculatedResults] = useState([]);
	const [tableHeader, setTableHeader] = useState([]);

	const mapResults = useEffect(() => {
		let correctOptions = new Set();
		let nameField, surnameField, emailField;
		let multipleChoiceElements = new Set();
		let formElements = new Set();
		for (var i = 0; i < currentCampaign.pages.length; i++) {
			const page = currentCampaign.pages[i];
			for (var j = 0; j < page.elements.length; j++) {
				const element = page.elements[j];
				if(element.type=="multipleChoice"){
					multipleChoiceElements.add(element.id);
					for (var k = 0; k < element.options.length; k++) {
						const option = element.options[k];
						if(option.isCorrect){
							correctOptions.add(option.id);
						}
					}
				}
				else if(element.type=="registrationForm"){
					formElements.add(element.id);
					for (var k = 0; k < element.fields.length; k++) {
						const f = element.fields[k];
						if(f.type==="email") emailField=f.id;
						else if(f.type==="firstName") nameField=f.id;
						else if(f.type==="lastName") surnameField=f.id;
					}
				}
			}
		}
		const userScores = [];
		for(const userId in unMappedUserResults){
			let u = {"name":null, "c":0};
			for(const pageId in unMappedUserResults[userId]){
				const elements = unMappedUserResults[userId][pageId]?.elements;
				for(const elementId in elements){
					const e = elements[elementId];
					if(multipleChoiceElements.has(elementId)){
						if(Array.isArray(e.value)){
							const selectedAnswers = e.value;
							for (let i = selectedAnswers.length - 1; i >= 0; i--) {
								if(correctOptions.has(selectedAnswers[i])) u.c++;
							}
						}
					}
					else if(formElements.has(elementId)){
						if(e.value && typeof e.value === "object"){
							if(nameField||surnameField){
								u.name = [e.value[nameField], e.value[surnameField]].filter(t=>!!t).join(" ");
							}else{
								u.name = e.value[emailField]||"";
							}
						}
					}
				}
			}
			userScores.push(u);
		}
		userScores.sort((a, b)=>b.c-a.c)

		setTableHeader([
			{"value": "name"},
			{"value": "correct"},
		]);
		setCalculatedResults(userScores.map((s)=>{
			return [
				s.name,
				s.c,
			]
		}));
	}, [currentCampaign, unMappedUserResults])
	const onDownloadExcel = useCallback(() => {
		let d = [];
		d.push(tableHeader.map(c=>c.value));
		calculatedResults.forEach((row)=>d.push(row));
		saveExcel(d, currentCampaign.name)
	}, [tableHeader, calculatedResults])

	return (
		<div className="numericPrediction__results">
			<div className="mtop--10">
				<div onClick={onDownloadExcel} className="dropdown-trigger btn btn-primary btn-inverted download__results mtop--5">
					Download Excel
				</div>
				<div className="mtop--20 table__wrapper">
					<DetailedResultsTable total={calculatedResults.length} header={tableHeader} rows={calculatedResults} />
				</div>
			</div>
		</div>
	);
}

export default QuizScoring;
